<template>
    <div id="partners" class="partners">
        <div class="wrapper">
            <h2>PARTNERS</h2>
        </div>
        <div class="slider" uk-slider="center: true; autoplay: true; autoplay-interval: 0; easing: linear; velocity: 0.03; draggable: false; pause-on-hover: false">
            <ul class="uk-slider-items">
                <li>
                    <img src="../assets/partners/skytech.png">
                </li>
                <li>
                    <img src="../assets/partners/sprzedambiznes.png">
                </li>
                <li>
                    <img class="vision" src="../assets/partners/visionapartments.jpg">
                </li>
                <li>
                    <img src="../assets/partners/skytech.png">
                </li>
                <li>
                    <img src="../assets/partners/sprzedambiznes.png">
                </li>
                <li>
                    <img class="vision" src="../assets/partners/visionapartments.jpg">
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
  export default {

	data () {
	  return {

        }
    },
  }
</script>

<style lang="scss" scoped>
    .partners {
        margin-top: -150px;

        .wrapper {
            justify-content: center;
            display: flex;
            padding-top: 250px;

            h2 {
                position: relative;
                text-align: center;
                display: inline-block;
                color: #ff5400;
                font-weight: 600;
                font-size: 14px;
                margin-bottom: 80px;
                letter-spacing: 3px;

                &::after {
                    content: 'Partners';
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    color: rgba(102, 102, 102, 0.3);
                    font-size: 100px;
                    font-family: kazimir, sans-serif;
                    font-weight: 300;
                }
            }
        }

        .slider {
                margin: 150px 0 100px;

            .vision {
                border: 1px solid rgba(102, 102, 102, 0.3);
            }

            img {
                height: 100px;
                margin: 0 100px
            }
        }

    }

    @media all and (max-width: 1200px) {
        .partners {
            // padding-top: 200px;
        }
    }

    @media all and (max-width: 970px) {
        .partners {
            margin-top: initial;

            img {
                height: 80px;
                margin: 0 80px
            }
        }
    }

    @media all and (max-width: 830px) {
        .partners {

            .wrapper {
                h2 {
                    &::after {
                        font-size: 70px;
                    }
                }
            }

            .slider {
                margin: 50px 0;
                img {
                    height: 80px;
                    margin: 0 80px
                }
            }
        }
    }

    @media all and (max-width: 530px) {
        .partners {
            .wrapper {
                padding-top: 200px;
                h2 {
                    margin-bottom: 40px;
                    font-size: 9px;

                    &::after {
                        font-size: 45px;
                    }
                }
            }


            .slider {
                margin: 70px 0;
                img {
                    height: 50px;
                    margin: 0 50px
                }
            }
        }
    }

    @media all and (max-width: 330px) {
        .partners {
            .wrapper {
                h2 {
                    margin-bottom: 35px;
                    font-size: 7px;

                    &::after {
                        font-size: 35px;
                    }
                }
            }
        }
    }

</style>